<template>
  <el-dialog title="账户创建" :visible.sync="dialogVisible" width="400px" top="32vh" center>
    <div>
      <el-row type="flex" justify="center" class="excelBtn">
        <el-col :span="8" class="font-blod">下载excel模版</el-col>
        <el-col :span="8">
          <el-button type="primary" @click="downloadExcelFun">
            <div class="btnclass">
              <img src="../../../assets/download.png" alt="">
              <span>excel模版下载</span>
            </div>
          </el-button>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" class="excelBtn">
        <el-col :span="8" class="font-blod">导入excel</el-col>
        <el-col :span="8">
          <file-upload ref="fileupload" @addUpload="importUpdateStockByExcel" :title="'+导入账户'" :limit="1" />
        </el-col>
      </el-row>
    </div>
    <div slot="footer" class="tableBtn">
      <div @click="cancelExcel">取 消</div>
      <div @click="submitExcel">确认导入</div>
    </div>

  </el-dialog>
</template>
<script>
import FileUpload from '@/components/Upload/fileUpload'
export default {
  components: {
    FileUpload
  },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      upLoadData: '',
      key: '',
      dialogType: 'admin' // admin | partner
    }
  },
  created () {

  },
  methods: {
    openDialog () {
      this.dialogVisible = true
    },
    closeDialog () {
      this.dialogVisible = false
    },
    downloadExcelFun () {
      let url = '/autoapp-recovery-server-auth/api/recoveryManage/downloadManageTemp'
      let title = '管理员账号模板'
      this.global.exportExcel(url, {}, title).catch((res) => {
        let blob = new Blob([res.response.data], {
          type: 'application/json',
        });
        var blobReader = new Response(blob).json();
        blobReader.then((res) => {
          this.$message.error(res.message);
        });
      });
    },
    importUpdateStockByExcel (item) {
      this.loading = true;
      this.upLoadData = item
    },
    cancelExcel () {
      this.dialogVisible = false
      this.key = ''
    },
    submitExcel () {
      if (!this.global.handleEmptyData(this.upLoadData)) {
        let formData = new FormData();
        formData.append("file", this.upLoadData.file);
        let url = `/autoapp-recovery-server-auth/api/recoveryManage/manageImport?type=${this.dialogType === 'partner' ? 2 : 1}`
        this.HttpService.post(url, formData).then(res => {
          if (res.statusCode != 200) {
            this.$message.error(res.message)
          } else {
            this.key = res.data
            this.confirmSubmitExcel()
          }
        })
      } else {
        this.$message.error('请上传文件')
      }
    },
    // 确认上传excel
    confirmSubmitExcel () {
      const url = `autoapp-recovery-server-auth/api/recoveryManage/manageTrueImport/${this.key}`
      this.HttpService.post(url).then(res => {
        if (res.statusCode != 200) {
          this.$message.error(res.message)
        } else {
          this.$message.success('导入成功')
        }
        this.cancelExcel()
      })
    }
  }
}
</script>
<style scoped lang='scss'>
.excelBtn {
  padding: 10px 0;
  display: flex;
  align-items: center;
}
.btnclass {
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/system/components/AddAdminDialog.vue